export function Footer() {
  return (
    <footer className="border-t border-parchment-400/60 mt-20 bg-parchment-50">
      <div className="max-w-5xl mx-auto px-6 py-6 text-xs flex flex-wrap gap-x-4 gap-y-2 justify-between items-center font-mono uppercase tracking-[0.15em] text-parchment-600">
        <span>
          cklibrary <span className="text-parchment-400">·</span> built on Nervos CKB{" "}
          <span className="text-parchment-400">·</span> immutable on chain
        </span>
        <a
          href="https://github.com/toastmanAu/cellbrary"
          target="_blank"
          rel="noreferrer"
          className="hover:text-parchment-900 transition-colors"
        >
          GitHub
        </a>
      </div>
    </footer>
  );
}
